import { render } from "./DCatalogueCreateEditDialog.vue?vue&type=template&id=66bfcbf0&scoped=true&ts=true"
import script from "./DCatalogueCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./DCatalogueCreateEditDialog.vue?vue&type=script&lang=ts"

import "./DCatalogueCreateEditDialog.vue?vue&type=style&index=0&id=66bfcbf0&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bfcbf0"]])

export default __exports__